export function getStored(key, fallback = null) {
  try {
    const value = localStorage.getItem(key);
    return value === null ? fallback : JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function setStored(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function addRecent(key, item, limit) {
  const current = getStored(key, []);
  const id = `${item.type || "listing"}-${item.id}`;
  const next = [item, ...current.filter((x) => `${x.type || "listing"}-${x.id}` !== id)];
  setStored(key, next.slice(0, limit));
  return next.slice(0, limit);
}

export const getListingView = () => localStorage.getItem("listing_view_mode") || "card";
export const setListingView = (mode) => localStorage.setItem("listing_view_mode", mode);
export const addRecentlyViewed = (item) => addRecent("recently_viewed", item, 20);
export const getRecentlyViewed = () => getStored("recently_viewed", []);
export const addSearchHistory = (query) => addRecent("search_history", { id: query.toLowerCase(), label: query }, 10);
export const getSearchHistory = () => getStored("search_history", []);

export function rememberAd(adId, action) {
  setStored(`ad_${adId}_${action}`, new Date().toISOString());
}

export function shouldShowAd(adId, frequency = "every") {
  if (frequency === "every") return true;
  const last = getStored(`ad_${adId}_shown`);
  if (!last) return true;

  const elapsed = Date.now() - new Date(last).getTime();
  return {
    once: false,
    daily: elapsed >= 86400000,
    weekly: elapsed >= 604800000,
    monthly: elapsed >= 2592000000,
  }[frequency] ?? true;
}
